import {WarningProps, Warning, FrameBody } from "@npd-ng/adp-benchmark";
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
export default function StressTestDisconnectedView() {
  const { state} = useStateContext();
  const content= state.staticContent as Content;
  const networkStressTest = content.deviceReadiness.FailedModeOneCheck
    const warningProps: WarningProps = {
      errorCode: networkStressTest.code,
      title: networkStressTest.title,
      message: networkStressTest.message,
      buttons:[{
          label: content.actions.exit,
          action:()=>{window.close()},
          variant: "secondary"
      }, ]
    }
  return (
       <FrameBody>
          <Warning {...warningProps}/>
      </FrameBody> 
  )
}